import { ReportFormat } from "@common/helpers/reports";
import {
    AccountingReportType,
    ACCOUNTING_REPORT_LABELS,
} from "@common/types/reports/report-type";
import { exportArAgingSummary } from "@api/accountingReports.api";
import { AccountingReportFilters } from "@components/accounting/types";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";

interface DownloadParams {
    format: ReportFormat;
    /** yyyy-MM-dd, resolved from the report response so the filename always matches what's shown. */
    asOfDate: string;
}

export function useArAgingSummaryDownload(filters: AccountingReportFilters) {
    return useFileDownload(async ({ format, asOfDate }: DownloadParams) => {
        const response = await exportArAgingSummary(filters, format);
        if (!response) {
            return;
        }

        const reportTypeTitle =
            ACCOUNTING_REPORT_LABELS[AccountingReportType.AR_AGING_SUMMARY];
        const fileName = `${reportTypeTitle} as of ${asOfDate}.${format}`;

        saveBlobResponse(response, fileName);
    });
}
